import axios from 'axios';
import { newAbortSignal } from '../../utils';
import { SessionStore } from '../../types/store/SessionStore';

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/auth/signoff`;

export const logout = async (): Promise<string> => {
  const session: SessionStore | undefined = JSON.parse(
      localStorage.getItem('session') || '{}'
    );

  return await axios
    .post<string>(
      BASE_URL,
      {},
      {
        headers: {
          'content-type': 'application/json',
          'x-access-token': session?.accessToken,
        },
        timeout: parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
        signal:
          typeof AbortSignal.timeout !== 'undefined'
            ? AbortSignal.timeout(
                parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)
              )
            : newAbortSignal(
                parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)
              ),
      }
    )
    .then((response) => response.data);
};
